<!-- Translated: skip -->
<template>
  <Modal @close="localClose" :wide="true" :fullwide="true" :show-close="true" class="center" :click-outside="false">

    <Slideshow :images="params.images" :fullsize="true" :image="params.image" style="width:100vw;max-width:100%;" />

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import Slideshow from '@/components/components/Slideshow';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    Slideshow,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    localClose() {
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
</style>



// WEBPACK FOOTER //
// SlideshowModal.vue?c833404a